// @flow
// ----------------------------------------------------------------------
// <copyright file='Izenda.DashboardDetail.js' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

import classnames from 'classnames';
import constants from 'logic/data/Izenda.DashboardConstants';
import uiState from 'logic/Izenda.UiState';
import DashboardSubscribe from 'modules/Dashboard/DashboardSubscribe/Izenda.DashboardSubscribe';
import React, { Component } from 'react';
import GridLayout from 'share/components/controls/Izenda.GridLayout';
import Panel from 'share/components/controls/Izenda.Panel';
import TextHighLight from 'share/components/controls/Izenda.TextHighLight';
import connect from 'share/enhancers/Izenda.Connect';
import convertToDateTimeFormat from 'share/utils/Izenda.ConvertToDateTimeFormat';
import routeUtils from 'share/utils/Izenda.RouteUtils';
import DashboardDetailFooter from './Izenda.DashboardDetailFooter';
import PropTypes from 'prop-types';
import { observable } from 'mobx';

const DashboardDetailHeader = require('share/components/controls/Izenda.BoardDetailHeader')(constants);

@connect()
class Body extends Component {
  renderItemInfo = (text: string, value: string, field: any) => {
    const {
      boardDetail,
      store: { items: model }
    } = this.props;

    return (
      <GridLayout.Row className='form-group'>
        <GridLayout.Col cols='6' xs='6'>
          <label className='control-label u_textGrayColor'>{text}: </label>
        </GridLayout.Col>
        <GridLayout.Col cols='6' xs='6'>
          <TextHighLight
            highlight={model.searchText}
            text={value}
            className='u_textNormal'
            notHighlight={boardDetail.isNotHighLight(model.searchType, field)}
          />
        </GridLayout.Col>
      </GridLayout.Row>
    );
  };
  render() {
    const SearchCriteria = constants.SEARCH_CRITERIA;
    const { boardDetail, localization } = this.props;
    return (
      <GridLayout>
        <GridLayout.Row>
          <GridLayout.Col
            cols='6'
            xs='12'
            className='dashboard-description overflow-text'
            title={boardDetail.description}
          >
            {boardDetail.description}
          </GridLayout.Col>
          <GridLayout.Col cols='6' xs='12' className='dashboard-detail-info'>
            <GridLayout.Row>
              <GridLayout.Col cols='6'>
                {this.renderItemInfo(
                  localization.getText('COMMON_CRITERIA_DASHBOARD_OWNER'),
                  boardDetail.owner,
                  'none'
                )}
                {this.renderItemInfo(
                  localization.getText('COMMON_CRITERIA_CREATED_BY'),
                  boardDetail.createdBy,
                  SearchCriteria[3].value
                )}
                {this.renderItemInfo(
                  localization.getText('COMMON_CRITERIA_EDITED_BY'),
                  boardDetail.modifiedBy,
                  SearchCriteria[5].value
                )}
                {this.renderItemInfo(
                  localization.getText('COMMON_CRITERIA_NUMBER_OF_VIEWS'),
                  boardDetail.numberOfView,
                  'none'
                )}
                {this.renderItemInfo(
                  localization.getText('COMMON_CRITERIA_AVERAGE_RENDERING_TIME'),
                  boardDetail.renderingTimeInSeconds,
                  'none'
                )}
              </GridLayout.Col>
              <GridLayout.Col cols='6'>
                {this.renderItemInfo(
                  localization.getText('COMMON_CRITERIA_VERSION'),
                  boardDetail.version && boardDetail.version.toString(),
                  'none'
                )}
                {this.renderItemInfo(
                  localization.getText('COMMON_CRITERIA_CREATED_DATE'),
                  convertToDateTimeFormat(uiState.currentUser.dateFormat, boardDetail.created),
                  SearchCriteria[4].value
                )}
                {this.renderItemInfo(
                  localization.getText('COMMON_CRITERIA_EDITED_DATE'),
                  convertToDateTimeFormat(uiState.currentUser.dateFormat, boardDetail.modified),
                  SearchCriteria[6].value
                )}
                {this.renderItemInfo(
                  localization.getText('COMMON_CRITERIA_LAST_VIEWED'),
                  convertToDateTimeFormat(uiState.currentUser.dateFormat, boardDetail.lastViewed),
                  'none'
                )}
              </GridLayout.Col>
            </GridLayout.Row>
          </GridLayout.Col>
        </GridLayout.Row>
      </GridLayout>
    );
  }
}

@connect()
export default class DashboardDetail extends Component {
  static propTypes = {
    store: PropTypes.object
  };

  constructor(props) {
    super(props);

    const { boardDetail, selectedDashboardId } = props;
    const activeItem = boardDetail.id === selectedDashboardId;

    boardDetail.setStateExpanded(activeItem);

  }

  onCloseCopyPopup = (message: string): any => {
    const props = this.props;
    const loader = props.loader;

    if (message) {
      return props
        .confirmFn('Information', {
          description: message,
          type: 'info',
          showCloseIndicator: true
        })
        .then(() => {
          loader.startLoading();
          return props.store.loadDashboardsData(props.DashboardDetail.type);
        })
        .finally(loader.endLoading.bind(loader));
    }
  };

  onCloseSubscribe = () => {
    const {
      props: {
        store: {
          model: { dashboardDesignerMode }
        }
      }
    } = this;

    dashboardDesignerMode.switchSubscribeMode(false);
  };

  render() {
    const {
      props,
      props: {
        boardDetail,
        store,
        store: {
          model,
          model: {
            dashboardDesignerMode,
            dashboardDetail: { dashboard }
          }
        },
        authorization,
        localization
      }
    } = this;

    const detailUri = {
      pathname: routeUtils.getDashboardUrl('Edit', { id: boardDetail.id }),
      state: {
        fromList: true
      }
    };

    const permissionKeys = props.authorizationConstants.PERMISSION_KEY;

    const header = {
      store,
      boardDetail,
      expanedOption: boardDetail.isShowDetail,
      component: DashboardDetailHeader,
      detailUri,
      accessPriority: boardDetail.accessPriority,
      hasRenamePermission: authorization.checkPrivileges([permissionKeys.DashboardsActionsOverwriteExistingDashboard])
    };

    const footer = {
      store,
      boardDetail,
      subCategory: props.subCategory,
      component: DashboardDetailFooter,
      detailUri
    };

    const isSubscribeMode = dashboard.id === boardDetail.id ? dashboardDesignerMode.isSubscribe : false;

    return (
      <Panel
        renderCollapseContent={true}
        header={header}
        footer={!isSubscribeMode && footer}
        collapsible
        expanedOption={boardDetail.isShowDetail}
        className={classnames('dashboard-detail', props.className)}
      >
        {isSubscribeMode ? (
          <DashboardSubscribe
            {...this.props}
            id={boardDetail.id}
            isDashboardMode
            onClose={this.onCloseSubscribe}
            doesSaveToDB
          />
        ) : (
          <Body boardDetail={boardDetail} store={store} />
        )}
      </Panel>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/Dashboard/DashboardList/Izenda.DashboardDetail.js